'use strict';

const AngularHelpers=require('../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.directives',
components:[
require('./addPersonAutocompleteDirective/addPersonAutocompleteDirective'),
require('./addressValidatorDirective/addressValidatorDirective'),
require('./aggregateStatisticsSummaryDirective/aggregateStatisticsSummaryDirective'),
require('./breadcrumbsDirective/breadcrumbsDirective'),
require('./checkMarkDirective/checkMarkDirective'),
require('./columnHeaderDirective/columnHeaderDirective'),
require('./currentDutyStatusDirective/currentDutyStatusDirective'),
require('./commandButtonDirective/commandButtonDirective'),
require('./commandCheckboxDirective/commandCheckboxDirective'),
require('./commandStatusDirective/commandStatusDirective'),
require('./connectionStatusMonitorDirective/connectionStatusMonitorDirective'),
require('./dateTimeDirective/dateTimeDirective'),
require('./deviationThresholdPickerDirective/deviationThresholdPickerDirective'),
require('./debugToolsDirective/debugToolsDirective'),
require('./digestSpeedMonitorDirective/digestSpeedMonitorDirective'),
require('./durationDirective'),
require('./dynamicStyleDirective'),
require('./estimatesAsOfStatusDirective/estimatesAsOfStatusDirective'),
require('./fatigueThresholdLabelDirective/fatigueThresholdLabelDirective'),
require('./faviconDirective'),
require('./fleetInsightAnalysisButtonDirective/fleetInsightAnalysisButtonDirective'),
require('./groupTreeDirective/groupTreeDirective'),
require('./ifRoleDirective'),
require('./thresholdStatusSummaryDirective/thresholdStatusSummaryDirective'),
require('./ifFmTypeDirective'),
require('./ifEnabledDirective'),
require('./intervalPickerDirective/intervalPickerDirective'),
require('./multiValueAutocompleteDirective/multiValueAutocompleteDirective'),
require('./multiViewDirective/multiViewDirective'),
require('./namespaceDirective'),
require('./navigationButtonDirective/navigationButtonDirective'),
require('./newPasswordValidatorsDirective/newPasswordValidatorsDirective'),
require('./notificationTypePickerDirective/notificationTypePickerDirective'),
require('./pdfViewerDirective'),
require('./plotting/categoryAxisDirective'),
require('./plotting/fatigueAlertPlotterDirective'),
require('./plotting/fatigueThresholdLineDirective'),
require('./plotting/graphGuideLinesDirective'),
require('./plotting/intervalPlotterDirective'),
require('./plotting/linearAxisDirective'),
require('./plotting/biLevelLinePlotterDirective'),
require('./plotting/incidentPlotterDirective'),
require('./plotting/svgPlotterDirective'),
require('./plotting/linePlotterDirective'),
require('./plotting/pointPlotterDirective'),
require('./plotting/plotAreaDirective'),
require('./plotting/textTicksDirective'),
require('./plotting/shiftedLinearAxisDirective'),
require('./plotting/timeAxisDirective'),
require('./plotting/timeAxisLabelDirective'),
require('./plotting/twentyFourHourAxisLabelDirective'),
require('./rippleButtonDirective'),
require('./remoteProgressDirective/remoteProgressDirective'),
require('./resizeDirective'),
require('./routeGraphDirective/routeGraphDirective'),
require('./routeMapDirective/routeMapDirective'),
require('./scheduleGraphDirective/scheduleGraphDirective'),
require('./scheduleWeekNavigatorDirective/scheduleWeekNavigatorDirective'),
require('./scrollbarDirective/scrollbarDirective'),
require('./searchDirective/searchDirective'),
require('./sharedWidth/sharedWidthSourceDirective'),
require('./sharedWidth/sharedWidthSubscriberDirective'),
require('./sortableTableDirective/sortableTableDirective'),
require('./sparklineDirective'),
require('./stateChangeDirective'),
require('./stateClassDirective'),
require('./scheduleRowDirective/scheduleRowDirective'),
require('./scheduleRowDirective/scheduleRowAxisDirective'),
require('./scheduleRowDirective/forecastRowDirective'),
require('./scheduleRowDirective/forecastRowAxisDirective'),
require('./scheduleRowDirective/multiForecastRowDirective'),
require('./statisticsPanels/baseStatisticsPanelDirective'),
require('./statisticsPanels/daysSinceLastIncident/daysSinceLastIncidentDirective'),
require('./statisticsPanels/daysSinceLastIncident/daysSinceLastIncidentGraphPanelDirective'),
require('./statisticsPanels/thresholdStatusDonut/thresholdStatusDonutDirective'),
require('./statisticsPanels/totalIncidents/totalIncidentsDirective'),
require('./statisticsPanels/totalIncidents/totalIncidentsGraphPanelDirective'),
require('./timelineGraphDirective/timelineGraphDirective'),
require('./thresholdSliderDirective/thresholdSliderDirective'),
require('./toggledItemsList/toggledItemsListDirective'),
require('./toggleSidebarButtonDirective'),
require('./tooltips/tooltipDirective'),
require('./tooltips/textTooltipDirective'),
require('./tooltips/incidentTooltip/incidentTooltipDirective'),
require('./tooltips/incidentTooltip/fleetIncidentTooltipDirective'),
require('./treeListDirective/treeListDirective'),
require('./treeListDirective/treeListItemDirective'),
require('./typeAheadDirective/typeAheadDirective'),
require('./userSettingsButtonDirective/userSettingsButtonDirective'),
require('./validatedFieldDirective/validatedFieldDirective'),
require('./validatedTimePickerDirective/validatedTimePickerDirective'),
require('./virtualRepeatShadowDirective'),
require('./weekIntervalPickerDirective/weekIntervalPickerDirective'),
require('./whilePressedDirective')]});
//# sourceMappingURL=index.js.map
